import { useSelector } from 'react-redux';

const useGetCarPlan = () => {
    return useSelector((state) => state.carPlan.car_plan);
};

export default useGetCarPlan;